// Payment methods and fees, the one card in Settings, Invoicing and Payments.
//
// The methods are saved by PUT /api/settings/payment-methods (keyed by id) and
// the fees by PUT /api/payment-method-fees, one row per method whose
// payment_method is the method id. A fee row is on exactly when its method is
// on. A method with no saved row reads as 0% + $0, except Square, which reads
// as its emailed-invoice rate, 3.30% + $0.30: the server fallback, migration
// 065's seed, and the rate the Expenses booking uses when the Square row is
// off or missing.

export const defaultFee = (methodId) => (
  methodId === 'square' ? { fee_percent: 3.30, fee_flat: 0.30 } : { fee_percent: 0, fee_flat: 0 }
);

// GET /api/payment-method-fees rows, keyed by method id. DECIMAL columns
// arrive as strings.
export const feesById = (rows) => {
  const byId = {};
  (Array.isArray(rows) ? rows : []).forEach((f) => {
    byId[f.payment_method] = { fee_percent: parseFloat(f.fee_percent) || 0, fee_flat: parseFloat(f.fee_flat) || 0 };
  });
  return byId;
};

export const feeFor = (fees, methodId) => fees[methodId] || defaultFee(methodId);

// A deleted method (soft delete, deleted: true) is sent off, so its fee
// stops being deducted exactly as when it is turned off.
export const feeRowsFor = (methods, fees) => methods.map((m) => ({
  payment_method: m.id,
  ...feeFor(fees, m.id),
  is_active: !!m.enabled && !m.deleted,
}));

// One Save, two endpoints in sequence. If the methods fail the fees are not
// sent; if the fees fail the message says the methods did save.
export async function saveMethodsAndFees(put, apiUrl, methods, fees) {
  try {
    await put(`${apiUrl}/api/settings/payment-methods`, { methods });
  } catch (err) {
    return { error: err.response?.data?.error || 'Failed to update payment methods' };
  }
  try {
    await put(`${apiUrl}/api/payment-method-fees`, { fees: feeRowsFor(methods, fees) });
  } catch (err) {
    const reason = err.response?.data?.error || 'Failed to update payment method fees';
    return { error: `The payment methods were saved, but the fees were not (${reason}). Save again to retry the fees.` };
  }
  return { success: 'Payment methods and fees saved' };
}
